import { Link } from "react-router-dom";
import type { VoteBrief } from "@/lib/types";
import { STATE_BADGE, STATE_LABEL, formatCountdown, formatDateTime, typeLabel } from "../utils";

interface Props {
  vote: VoteBrief;
  remaining?: number;
}

// /vote 목록 카드
export default function VoteCard({ vote, remaining }: Props) {
  const open = vote.state === "open";

  return (
    <Link
      to={`/vote/${vote.no}`}
      className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100/60"
    >
      <div className="flex flex-wrap items-center gap-2">
        <span className="inline-block rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-semibold text-primary-700">
          {typeLabel(vote.vtype, vote.type_txt)}
        </span>
        <span
          className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATE_BADGE[vote.state]}`}
        >
          {STATE_LABEL[vote.state]}
        </span>
        {vote.is_anon === 1 && (
          <span className="inline-block rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-900">
            익명
          </span>
        )}
        {vote.is_joined === 1 && (
          <span className="inline-block rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-900">
            참여완료
          </span>
        )}
      </div>

      <h3 className="mt-3 line-clamp-2 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
        {vote.subject || vote.title || "투표"}
      </h3>

      <p className="mt-2 text-xs text-foreground-500">
        {formatDateTime(vote.start_date)} ~ {formatDateTime(vote.end_date)}
      </p>

      <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
          <i className="ri-group-line" aria-hidden="true"></i>
          참여 {vote.join_cnt}명
        </span>
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
          <i className="ri-question-line" aria-hidden="true"></i>
          문항 {vote.q_cnt}개
        </span>
      </div>

      {open && typeof remaining === "number" && (
        <div className="mt-3 flex items-center justify-between rounded-lg bg-background-100 px-3 py-2">
          <span className="text-xs text-foreground-500">종료까지</span>
          <span className="font-heading text-sm font-bold tabular-nums text-accent-700">
            {formatCountdown(remaining)}
          </span>
        </div>
      )}
      {vote.state === "closed" && (
        <div className="mt-3 rounded-lg bg-background-100 px-3 py-2 text-center text-xs font-medium text-foreground-400">
          종료된 {typeLabel(vote.vtype, vote.type_txt)}입니다
        </div>
      )}
    </Link>
  );
}